import { InjectionToken } from '@angular/core';
import { GoogleTagManager } from '../models/google-tag-manager.type';

export const GOOGLE_TAG_MANAGER = new InjectionToken<GoogleTagManager>(
  'GoogleTagManager',
  {
    factory: (): GoogleTagManager => {
      return (
        (window as { dataLayer?: GoogleTagManager })?.dataLayer || {
          push: () => console.warn('window.dataLayer is not defined.'),
        }
      );
    },
  },
);
